import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface IStockAddManuelItemCountPop_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IStockAddManuelItemCountPop_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  HS_StockGetItemById: any[];
  HS_StockGetItemById_dummy: any[];
  InventoryCountLineInsert: any[];
  InventoryCountLineInsert_dummy: any[];
  GoBack: any;
  GoBack_dummy: any;
}

export class StockAddManuelItemCountPop_ScreenBase extends React.PureComponent<
  IStockAddManuelItemCountPop_ScreenProps,
  any
> {
  ml = [
    {
      Id: "70da2015-72e4-4a73-bc3e-b700175ae3a3",
      Name: "en_US",
      ShortName: "English",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "a3a383a1-b83e-41a2-80ac-49fc52a9b06e",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 832211, PropertyName: "value", Value: "Çıkar/Ekle" },
        { Id: 453837, PropertyName: "value", Value: "Miktar" },
        { Id: 38309, PropertyName: "placeholder", Value: "15" },
        { Id: 71335, PropertyName: "value", Value: "Kategori" },
        { Id: 927273, PropertyName: "value", Value: "Marka" },
        { Id: 174118, PropertyName: "label", Value: "Ekle" },
      ],
    },
  ];
  defaultML = "en_US";

  screenHash = "";

  constructor(props) {
    super(props);

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      HS_StockGetItemById: [],
      InventoryCountLineInsert: [],
      GoBack: "",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight(
        "stockaddmanuelitemcountpop",
        ""
      );
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.StockAddManuelItemCountPopPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("stockaddmanuelitemcountpop", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("stockaddmanuelitemcountpop", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.StockAddManuelItemCountPopPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({
      stockaddmanuelitemcountpop_810495_value: true,
      stockaddmanuelitemcountpop_38309_value: 1,
    });
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  StockAddManuelItemCountPopPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      Id_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.ItemID ?? this.props.screenInputs.itemid,
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "StockAddManuelItemCountPop/StockAddManuelItemCountPopPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.HS_StockGetItemById = result?.data.hS_StockGetItemById;
    formVars.stockaddmanuelitemcountpop_766443_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.HS_StockGetItemById !== undefined
          ? stateVars.HS_StockGetItemById?.length > 0
            ? stateVars.HS_StockGetItemById[0].itemCode
            : null
          : this.state.HS_StockGetItemById?.length > 0
          ? this.state.HS_StockGetItemById[0].itemCode
          : null
      );
    formVars.stockaddmanuelitemcountpop_197213_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.HS_StockGetItemById !== undefined
          ? stateVars.HS_StockGetItemById?.length > 0
            ? stateVars.HS_StockGetItemById[0].itemDescription
            : null
          : this.state.HS_StockGetItemById?.length > 0
          ? this.state.HS_StockGetItemById[0].itemDescription
          : null
      );
    formVars.stockaddmanuelitemcountpop_145223_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.HS_StockGetItemById !== undefined
          ? stateVars.HS_StockGetItemById?.length > 0
            ? stateVars.HS_StockGetItemById[0].productAtt01Desc
            : null
          : this.state.HS_StockGetItemById?.length > 0
          ? this.state.HS_StockGetItemById[0].productAtt01Desc
          : null
      );
    formVars.stockaddmanuelitemcountpop_774306_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.HS_StockGetItemById !== undefined
          ? stateVars.HS_StockGetItemById?.length > 0
            ? stateVars.HS_StockGetItemById[0].productAtt02Desc
            : null
          : this.state.HS_StockGetItemById?.length > 0
          ? this.state.HS_StockGetItemById[0].productAtt02Desc
          : null
      );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.StockAddManuelItemCountPopPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  StockAddManuelItemCountPopPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.stockaddmanuelitemcountpop_766443_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.HS_StockGetItemById !== undefined
          ? stateVars.HS_StockGetItemById?.length > 0
            ? stateVars.HS_StockGetItemById[0].itemCode
            : null
          : this.state.HS_StockGetItemById?.length > 0
          ? this.state.HS_StockGetItemById[0].itemCode
          : null
      );

    formVars.stockaddmanuelitemcountpop_197213_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.HS_StockGetItemById !== undefined
          ? stateVars.HS_StockGetItemById?.length > 0
            ? stateVars.HS_StockGetItemById[0].itemDescription
            : null
          : this.state.HS_StockGetItemById?.length > 0
          ? this.state.HS_StockGetItemById[0].itemDescription
          : null
      );

    formVars.stockaddmanuelitemcountpop_145223_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.HS_StockGetItemById !== undefined
          ? stateVars.HS_StockGetItemById?.length > 0
            ? stateVars.HS_StockGetItemById[0].productAtt01Desc
            : null
          : this.state.HS_StockGetItemById?.length > 0
          ? this.state.HS_StockGetItemById[0].productAtt01Desc
          : null
      );

    formVars.stockaddmanuelitemcountpop_774306_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.HS_StockGetItemById !== undefined
          ? stateVars.HS_StockGetItemById?.length > 0
            ? stateVars.HS_StockGetItemById[0].productAtt02Desc
            : null
          : this.state.HS_StockGetItemById?.length > 0
          ? this.state.HS_StockGetItemById[0].productAtt02Desc
          : null
      );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  StockAddManuelItemCountPopComponent_174118_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      InventoryCountHeaderId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CountHeaderID ??
          this.props.screenInputs.countheaderid,
        "Guid"
      ),
      Barcode_0: ReactSystemFunctions.convertToTypeByName("", "string"),
      ItemCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.HS_StockGetItemById !== undefined
            ? stateVars.HS_StockGetItemById?.length > 0
              ? stateVars.HS_StockGetItemById[0].itemCode
              : null
            : this.state.HS_StockGetItemById?.length > 0
            ? this.state.HS_StockGetItemById[0].itemCode
            : null
        ),
        "string"
      ),
      IsAdd_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stockaddmanuelitemcountpop_810495_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "boolean"
      ),
      CountQty_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stockaddmanuelitemcountpop_38309_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      ColorCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.HS_StockGetItemById !== undefined
            ? stateVars.HS_StockGetItemById?.length > 0
              ? stateVars.HS_StockGetItemById[0].colorCode
              : null
            : this.state.HS_StockGetItemById?.length > 0
            ? this.state.HS_StockGetItemById[0].colorCode
            : null
        ),
        "string"
      ),
      ColorDescription_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.HS_StockGetItemById !== undefined
            ? stateVars.HS_StockGetItemById?.length > 0
              ? stateVars.HS_StockGetItemById[0].colorDescription
              : null
            : this.state.HS_StockGetItemById?.length > 0
            ? this.state.HS_StockGetItemById[0].colorDescription
            : null
        ),
        "string"
      ),
      ItemDescription_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.HS_StockGetItemById !== undefined
            ? stateVars.HS_StockGetItemById?.length > 0
              ? stateVars.HS_StockGetItemById[0].itemDescription
              : null
            : this.state.HS_StockGetItemById?.length > 0
            ? this.state.HS_StockGetItemById[0].itemDescription
            : null
        ),
        "string"
      ),
      ItemDim1Code_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.HS_StockGetItemById !== undefined
            ? stateVars.HS_StockGetItemById?.length > 0
              ? stateVars.HS_StockGetItemById[0].itemDim1Code
              : null
            : this.state.HS_StockGetItemById?.length > 0
            ? this.state.HS_StockGetItemById[0].itemDim1Code
            : null
        ),
        "string"
      ),
      ItemDim2Code_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.HS_StockGetItemById !== undefined
            ? stateVars.HS_StockGetItemById?.length > 0
              ? stateVars.HS_StockGetItemById[0].itemDim2Code
              : null
            : this.state.HS_StockGetItemById?.length > 0
            ? this.state.HS_StockGetItemById[0].itemDim2Code
            : null
        ),
        "string"
      ),
      ItemDim3Code_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.HS_StockGetItemById !== undefined
            ? stateVars.HS_StockGetItemById?.length > 0
              ? stateVars.HS_StockGetItemById[0].itemDim3Code
              : null
            : this.state.HS_StockGetItemById?.length > 0
            ? this.state.HS_StockGetItemById[0].itemDim3Code
            : null
        ),
        "string"
      ),
      ItemTypeCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.HS_StockGetItemById !== undefined
            ? stateVars.HS_StockGetItemById?.length > 0
              ? stateVars.HS_StockGetItemById[0].itemTypeCode
              : null
            : this.state.HS_StockGetItemById?.length > 0
            ? this.state.HS_StockGetItemById[0].itemTypeCode
            : null
        ),
        "string"
      ),
      ItemTypeDescription_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.HS_StockGetItemById !== undefined
            ? stateVars.HS_StockGetItemById?.length > 0
              ? stateVars.HS_StockGetItemById[0].itemTypeDescription
              : null
            : this.state.HS_StockGetItemById?.length > 0
            ? this.state.HS_StockGetItemById[0].itemTypeDescription
            : null
        ),
        "string"
      ),
      ProductAtt01Desc_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.HS_StockGetItemById !== undefined
            ? stateVars.HS_StockGetItemById?.length > 0
              ? stateVars.HS_StockGetItemById[0].productAtt01Desc
              : null
            : this.state.HS_StockGetItemById?.length > 0
            ? this.state.HS_StockGetItemById[0].productAtt01Desc
            : null
        ),
        "string"
      ),
      ProductAtt02Desc_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.HS_StockGetItemById !== undefined
            ? stateVars.HS_StockGetItemById?.length > 0
              ? stateVars.HS_StockGetItemById[0].productAtt02Desc
              : null
            : this.state.HS_StockGetItemById?.length > 0
            ? this.state.HS_StockGetItemById[0].productAtt02Desc
            : null
        ),
        "string"
      ),
      UnitOfMeasureCode1_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.HS_StockGetItemById !== undefined
            ? stateVars.HS_StockGetItemById?.length > 0
              ? stateVars.HS_StockGetItemById[0].unitOfMeasureCode1
              : null
            : this.state.HS_StockGetItemById?.length > 0
            ? this.state.HS_StockGetItemById[0].unitOfMeasureCode1
            : null
        ),
        "string"
      ),
      UnitOfMeasureCode2_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.HS_StockGetItemById !== undefined
            ? stateVars.HS_StockGetItemById?.length > 0
              ? stateVars.HS_StockGetItemById[0].unitOfMeasureCode2
              : null
            : this.state.HS_StockGetItemById?.length > 0
            ? this.state.HS_StockGetItemById[0].unitOfMeasureCode2
            : null
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "StockAddManuelItemCountPop/StockAddManuelItemCountPopComponent_174118_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.InventoryCountLineInsert = result?.data.inventoryCountLineInsert;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.StockAddManuelItemCountPopComponent_174118_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  StockAddManuelItemCountPopComponent_174118_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.InventoryCountLineInsert !== undefined
            ? stateVars.InventoryCountLineInsert?.length > 0
              ? stateVars.InventoryCountLineInsert[0].result
              : null
            : this.state.InventoryCountLineInsert?.length > 0
            ? this.state.InventoryCountLineInsert[0].result
            : null
        ),
        "SUCCESS"
      )
    ) {
      stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

      this.props.form?.setFieldsValue(formVars);
      this.setState(stateVars);
      KuikaAppManager.hideSpinner(this);
    } else {
      KuikaAppManager.hideSpinner(this);
    }

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.StockAddManuelItemCountPopPageInit();
    }
  }
}
